import settings from '@/settings'

const mudarStatusPaciente = (headers, id) => {
    return fetch(`${settings.fisioApi}/admin/status-paciente/?id_paciente=${id}`, {
        method: 'PUT',
        mode: 'cors',
        cache: 'default',
        headers: headers,
    })
}

export default {
    mudarStatusPaciente,
}